export default () => ({
  dasbhoard: null,
  clientReview: null,
  clientInspections: []
})



// WEBPACK FOOTER //
// ./src/store/modules/dashboard/state.js